// src/pages/Admin/AdminLayout.jsx
import React, { useState} from "react";
import { NavLink, Routes, Route } from "react-router-dom";

import AdminDashboardPage from "./AdminDashboardPage";
import AdminProductsPage from "./AdminProductsPage";
import AdminOrdersPage from "./AdminOrdersPage";
import AdminCustomersPage from "./AdminCustomersPage";
import AdminReviewsPage from "./AdminReviewsPage";
import AdminEmailCampaignPage from "./AdminEmailCampaignPage";
import AdminRestockRequests from "./AdminRestockRequests";
// IMPORT THE BILLING PAGES
import InvoicesList from "./InvoicesList";
import ManualBilling from "./ManualBilling";

// ✅ IMPORT THE NEW WARRANTY PAGE
import AdminWarrantyRegistration from "./AdminWarrantyRegistration";

import "./admin.css";

const AdminSidebar = ({ isOpen, onClose }) => (
  <aside className={`admin-sidebar ${isOpen ? "open" : ""}`}>
    <div className="sidebar-header">
      <h2 className="admin-logo">Admin</h2>
      <button
        className="sidebar-close-btn"
        onClick={onClose}
        aria-label="Close sidebar"
      >
        ✕
      </button>
    </div>
    <nav>
      <NavLink end to="/admin" className="admin-nav-link" onClick={onClose}>
        📊 Dashboard
      </NavLink>
      <NavLink
        to="/admin/products"
        className="admin-nav-link"
        onClick={onClose}
      >
        📦 Products
      </NavLink>
      <NavLink to="/admin/orders" className="admin-nav-link" onClick={onClose}>
        🛒 Orders
      </NavLink>

      {/* ===== Billing Section ===== */}
      <div
        className="nav-group-title"
        style={{
          margin: "16px 0 8px 16px",
          fontSize: "0.75rem",
          fontWeight: "bold",
          color: "#9ca3af",
          textTransform: "uppercase",
        }}
      >
        Billing
      </div>
      <NavLink
        end
        to="/admin/invoices"
        className="admin-nav-link"
        onClick={onClose}
      >
        📄 Invoice List
      </NavLink>
      <NavLink
        to="/admin/invoices/manual"
        className="admin-nav-link"
        onClick={onClose}
      >
        ➕ Manual Bill Generator
      </NavLink>

      {/* ===== ✅ NEW: Warranty Section ===== */}
      <div
        className="nav-group-title"
        style={{
          margin: "16px 0 8px 16px",
          fontSize: "0.75rem",
          fontWeight: "bold",
          color: "#9ca3af",
          textTransform: "uppercase",
        }}
      >
        Warranty & Support
      </div>
      <NavLink
        to="/admin/warranty/register"
        className="admin-nav-link"
        onClick={onClose}
      >
        🛡️ Register Warranty
      </NavLink>

      {/* ===== Other Sections ===== */}
      <div
        className="nav-group-title"
        style={{
          margin: "16px 0 8px 16px",
          fontSize: "0.75rem",
          fontWeight: "bold",
          color: "#9ca3af",
          textTransform: "uppercase",
        }}
      >
        Management
      </div>
      <NavLink
        to="/admin/customers"
        className="admin-nav-link"
        onClick={onClose}
      >
        👥 Customers
      </NavLink>
      <NavLink to="/admin/reviews" className="admin-nav-link" onClick={onClose}>
        ⭐ Product Reviews
      </NavLink>
      <NavLink
        to="/admin/campaign"
        className="admin-nav-link"
        onClick={onClose}
      >
        📢 Email Campaign
      </NavLink>

      <NavLink
        to="/admin/products"
        className="admin-nav-link"
        onClick={onClose}
      >
        📦 Products
      </NavLink>
      {/* ADD THIS NEW LINK */}
      <NavLink
        to="/admin/restock-requests"
        className="admin-nav-link"
        onClick={onClose}
      >
        🔔 Restock Alerts
      </NavLink>
    </nav>
  </aside>
);

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="admin-layout">
      <AdminSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <section className="admin-main">
        {/* ===== Top Header ===== */}
        <header className="admin-topbar">
          <button
            className="hamburger-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            ☰
          </button>
          <h1>Admin Panel</h1>
        </header>

        {/* ===== Overlay for mobile ===== */}
        {sidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* ===== Main Page Content ===== */}
        <div className="admin-content">
          <Routes>
            <Route index element={<AdminDashboardPage />} />
            <Route path="products" element={<AdminProductsPage />} />
            <Route path="orders" element={<AdminOrdersPage />} />
            <Route path="customers" element={<AdminCustomersPage />} />
            <Route path="reviews" element={<AdminReviewsPage />} />
            <Route path="campaign" element={<AdminEmailCampaignPage />} />

            <Route path="invoices" element={<InvoicesList />} />
            <Route path="invoices/manual" element={<ManualBilling />} />
            <Route path="products" element={<AdminProductsPage />} />
            {/* ADD THIS NEW ROUTE */}
            <Route path="restock-requests" element={<AdminRestockRequests />} />

            {/* ✅ NEW ROUTE FOR WARRANTY */}
            <Route
              path="warranty/register"
              element={<AdminWarrantyRegistration />}
            />
          </Routes>
        </div>

        {/* ===== Global Admin Footer ===== */}
        <footer className="admin-footer">
          <p>© {new Date().getFullYear()} Zynvert Technologies • Admin Panel</p>
        </footer>
      </section>
    </div>
  );
};

export default AdminLayout;
